/**
 * EmptyTaskState Component
 * Centered empty state placeholder for task lists.
 */

import { ClipboardList } from 'lucide-react';
import styled from 'styled-components';

export interface EmptyTaskStateProps {
  message?: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing[12]} ${theme.spacing[4]}`};
  gap: ${({ theme }) => theme.spacing[3]};
  color: ${({ theme }) => theme.colors.text.light};
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.borders.medium};
`;

const Message = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.light};
  margin: 0;
  text-align: center;
`;

export function EmptyTaskState({ message = 'No tasks found' }: EmptyTaskStateProps) {
  return (
    <Wrapper role="status" aria-live="polite">
      <IconWrapper aria-hidden="true">
        <ClipboardList size={40} strokeWidth={1.5} />
      </IconWrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
}

export default EmptyTaskState;
